import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {isAuthenticated} from 'components/utils/Session';
function AuthRoute({ component: Component, ...rest }) {
    return (
        <Route
        {...rest}
        render={props =>
            !isAuthenticated() ? (
            <Component {...props} />
            ) : (
            <Redirect
                to={{
                pathname: "/accounts",
                state: { from: props.location }
                }}
            />
            )
        }
        />
    );
}
export default AuthRoute;